
const base = {
    /**
     * Show a toast notification.
     */
    showToast: (message, type = 'success', duration = 5000, position = 'bottom-left') => {
        if (window.toast) {

           if(Array.isArray(message)) {
                message.forEach(msg => {
                    window.toast.open({
                        message: msg,
                        type,
                        duration,
                        position
                    });
                });
                return;
            }

            if (typeof message === 'object' && message !== null) {
                let keys = Object.keys(message);
                if (keys.length === 0) {
                    message = 'Помилка';
                } else {
                    message = keys.map(key => `${message[key]}`).join('\n');
                }
            }

            window.toast.open({
                message,
                type,
                duration,
                position
            });
        } else {
            console.warn('Toast notification system is not initialized.');
        }
    },

    handleAxiosError: (error) => {
        if (error.response) {
            return {
                type: 'response',
                status: error.response.status,
                data: error.response.data,
                message: error.response.data.message || 'Server error',
                errors: error.response.data.errors || null,
            };
        } else if (error.request) {
            return { type: 'request', message: 'No response from server' };
        } else {
            return { type: 'general', message: error.message };
        }
    },

    copyToClipboard: (text) => {
            navigator.clipboard.writeText(text)
                .then(() => {
                    base.showToast('Скопійовано в буфер обміну', 'success');
                })
                .catch(err => {
                    console.error('Failed to copy text: ', err);
                    base.showToast('Не вдалося скопіювати текст', 'error');
        });
    }
};


export {
    base
};
